import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';
import { usePermission } from '../../components/permission/perm-evidence-hook';
import { DictionaryDirpLawParagraphsFields } from './dict-dirp-law-paragraphs-fields';
import { useValidationSchema } from './dict-dirp-law-paragraphs-schema';
import { useColumns } from './dict-dirp-law-paragraphs-columns';
import { DictionaryLaw, DictionaryLawParagraph } from '../../models';
import {
  Permission,
  PageKey,
  EvidenceAPI,
  Messages,
  EntityName,
} from '../../enums';
import { ExportTags } from '../../enums/export-tags';
import { createItemFactory, updateItemFactory } from '../../utils/custom-crud';
import { getErrorMessage } from '../../utils/get-message';

export function DictionaryDirpLawParagraphs() {
  const validationSchema = useValidationSchema();

  const permissions = usePermission({
    options: {
      NEW: [Permission.Dirp.DIRP_LAW_UPDATE],
      EDIT: [Permission.Dirp.DIRP_LAW_UPDATE],
      REMOVE: [],
      CHECK: [Permission.Dirp.DIRP_LAW_UPDATE],
      SAVE: [Permission.Dirp.DIRP_LAW_UPDATE],
      CLOSE: [Permission.Dirp.DIRP_LAW_UPDATE],
    },
  });

  const evidence = useDictionaryEvidence<DictionaryLawParagraph>(
    {
      identifier: PageKey.DICTIONARY_DIRP_LAW_PARAGRAPHS,
      apiProps: {
        url: EvidenceAPI.DICTIONARY_DIRP_LAW_PARAGRAPHS,
        createItem: createItemFactory<DictionaryLawParagraph>({
          postprocessCall: (data, response) => {
            if (!response?.ok) {
              const message = getErrorMessage(
                Messages.Dirp.PARAGRAPH_CREATE,
                data.code
              )[0];

              throw { message };
            }
          },
        }),
        updateItem: updateItemFactory<DictionaryLaw>({
          postprocessCall: (data, response) => {
            if (!response?.ok) {
              const message = getErrorMessage(
                Messages.Dirp.PARAGRAPH_UPDATE,
                data.code
              )[0];

              throw { message };
            }
          },
        }),
      },
      tableProps: {
        tableName: 'Paragrafy předpisů',
        reportTag: ExportTags.DICTIONARY_DIRP_LAW_PARAGRAPHS,
        showColumn: (col) =>
          !['ORDER', 'NAME', 'CODE', 'VALID_FROM', 'VALID_TO'].includes(col),
        columns: useColumns(),
        defaultSorts: [],
      },
      detailProps: {
        entityName: EntityName.DIRP_LAW_PARAGRAPH,
        codePrefix: 'DIRP_LAW_PARAGRAPH',
        validationSchema,
        hideGeneralFields: true,
        FieldsComponent: DictionaryDirpLawParagraphsFields,
        toolbarProps: {
          title: 'Paragraf předpisu',
          showBtn: permissions,
        },
        initNewItem: () => ({ code: uuidv4() } as DictionaryLawParagraph),
      },
    },
    Permission.Dirp.DIRP_LAW_INVALIDATE,
    Permission.Dirp.DIRP_LAW_REVALIDATE
  );

  return <Evidence {...evidence} />;
}
